import styled from 'styled-components';
import { Button } from '../form';
import { H3 } from '../Text';
import { Flex, FlexCss } from '../Flex';

export const Card = styled.div` ${({ theme }) => `
  width:100%; 
  background: ${theme.colours.neutral[10]};
  color: ${theme.textPrimary};
  margin-bottom:${theme.padding[4]};
  padding-top:${theme.padding[2]};
  border-radius:${theme.borderRadius[1]};
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
`}`;

export const ColumnHeader = styled(H3)` ${({ theme }) => `
  color: ${theme.textPrimary};
  box-sizing: border-box;
`}`;

export const CardHeader = styled(Flex)` ${() => `
  justify-content: space-between;
  align-items: center;
`}`;

export const CardTitle = styled(H3)` ${({ theme }) => `
  ${FlexCss}
  gap:${theme.padding[3]};
  color: ${theme.textPrimary};
  font-size: ${theme.fontSize[3]};
`}`;

export const CardText = styled.p` ${({ theme }) => `
  color: ${theme.textSecondary};
`}`;

export const CardButton = styled(Button)` ${({ theme }) => `
  min-width:auto;
  align-self:flex-end;
  background: ${theme.primary};
`}`;

export const BreakLine = styled.div<{ small?: boolean, fitOuter?: boolean, gap?: string }>`${({
  theme, small, fitOuter, gap,
}) => `
  margin: ${gap ?? theme.padding[7]} 0;
  height: ${small ? theme.borderWidth[2] : theme.borderWidth[3]};
  background-color: ${theme.colours.neutral[8]};
  ${fitOuter ? `margin-left: calc(0px - ${theme.padding[7]});` : ''}
  ${fitOuter ? `margin-right: calc(0px - ${theme.padding[7]});` : ''}
`}`;

export const BreakLineXs = styled(BreakLine)` ${({ theme }) => `
  height: ${theme.borderWidth[1]};
  background-color: ${theme.colours.neutral[7]};
`}`;

export const CardInnerHeader = styled.div`${({ theme }) => `
  background-color: ${theme.colours.neutral[8]};
  padding: 5px 16px;
  border-radius: ${theme.padding[2]} ${theme.padding[2]} 0 0;

  margin-left: calc(0px - ${theme.padding[7]});
  margin-right: calc(0px - ${theme.padding[7]});
  margin-bottom: ${theme.padding[4]};

  color: ${theme.colours.neutral[2]};
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
  line-height: ${theme.fontSize[6]}; 
`}`;

export const CardInner = styled.div`${({ theme }) => `
  background-color: ${theme.colours.neutral[9]};
  box-shadow: 0px 4px 5px -2px rgba(1, 50, 123, 0.15) inset;
  padding: ${theme.padding[7]} calc(${theme.padding[5]} + ${theme.padding[8]});
  border-radius: 0px 0px ${theme.padding[2]} ${theme.padding[2]};

  margin-left: calc(0px - ${theme.padding[5]} - ${theme.padding[8]});
  margin-right: calc(0px - ${theme.padding[5]} - ${theme.padding[8]});
`}`;
